export function dateToString(date) {
	var month = date.getMonth() + 1;
	var day = date.getDate();
	var hour = date.getHours();
	var minute = date.getMinutes();
	var dateOfString = date.getFullYear() + "-";
	dateOfString += (("" + month).length < 2 ? "0" : "") + month + "-";
	dateOfString += (("" + day).length < 2 ? "0" : "") + day;
	dateOfString += "T";
	dateOfString += (("" + hour).length < 2 ? "0" : "") + hour;
	dateOfString += ":";
	dateOfString += (("" + minute).length < 2 ? "0" : "") + minute;
	return dateOfString;
}

export function getFormattedDateTime(inputDate) {
	let now = new Date();

	if (!inputDate || inputDate === "0001-01-01T00:00:00") {
		return dateToString(now);
	} else {
		now = new Date(inputDate);
		return dateToString(now);
	}
}

export function BatchName(input) {
	var date = new Date(input);
	var hour = date.getHours();
	var minute = date.getMinutes();
	var month = date.getMonth() + 1;
	var dateOfString = (date.getFullYear() - 2000).toString();
	dateOfString += (("" + month).length < 2 ? "0" : "") + month;
	dateOfString +=
		(("" + date.getDate()).length < 2 ? "0" : "") + date.getDate() + "_";
	dateOfString += (("" + hour).length < 2 ? "0" : "") + hour;
	dateOfString += (("" + minute).length < 2 ? "0" : "") + minute;
	return dateOfString;
}

export function FormatOutDate(input) {
	var date = new Date(input);
	var year = date.getFullYear().toString().slice(-2); // Get the last two digits of the year
	var month = date.getMonth() + 1;
	var day = date.getDate();
	var hour = date.getHours();
	var minute = date.getMinutes();
  
	// Format the date string with MM/DD/YY HH:mm
	var dateStr = (("" + month).length < 2 ? "0" : "") + month + "/";
	dateStr += (("" + day).length < 2 ? "0" : "") + day + "/";
	dateStr += year + " "; 
	dateStr += (("" + hour).length < 2 ? "0" : "") + hour + ":";
	dateStr += (("" + minute).length < 2 ? "0" : "") + minute;
  
	return dateStr;
  }
  

// VLP saves a blank Test Date as 1/1/1900 and shows anything before 1901 as
// blank; treat those (and empty/0001-01-01 values) as "no date" the same way.
export function isNoDate(value) {
	return !value || String(value) < "1901";
}
